import { AppBar, Tab, Tabs, useTheme } from '@material-ui/core'
import { Redirect, useLocation } from 'react-router-dom'

import { buildFeatureSet, canAccessTab, getCredentials } from '../../cache/auth'
import PageHeader from '../../components/PageHeader'
import { TabPanel } from '../../helpers/TabPanel'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import priceClassRoleManagement from '../../staticRoleManagement/priceClassRoleManagement'
import PriceClassDistributions from '../PriceClassDistributions'
import PriceClassExchangeRate from '../PriceClassExchangeRate'
import PriceClassList from '../PriceClassList'
import PriceClassRateConnection from '../PriceClassRateConnection'
import useStyles from './styles/index.styles'

export default function PriceClassManagmentTabs() {
  const classes = useStyles()
  const theme = useTheme()
  const { pathname } = useLocation()
  const page = pathname.slice(pathname.lastIndexOf('/') + 1)

  const tabsList = [
    {
      label: getTranslate('Price Class'),
      value: 'price-class',
      to: '/price-class-managment/price-class',
      component: <PriceClassList />
    },
    {
      label: getTranslate('Subscribe'),
      value: 'subscribe',
      to: '/price-class-managment/subscribe',
      component: <PriceClassRateConnection />
    },
    {
      label: getTranslate('Distributions'),
      value: 'distributions',
      to: '/price-class-managment/distributions',
      component: <PriceClassDistributions />
    },
    {
      label: getTranslate('Exchange Rates'),
      value: 'exchange-rates',
      to: '/price-class-managment/exchange-rates',
      component: <PriceClassExchangeRate />
    }
  ]

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const routeConfig = priceClassRoleManagement.find(
    (item) => item.route === '/price-class-managment/:page'
  )

  const visibleTabs = tabsList.filter((tab) =>
    canAccessTab(routeConfig, tab.value, featureSet)
  )

  if (!canAccessTab(routeConfig, page, featureSet)) {
    return <Redirect to="/403" />
  }

  return (
    <div className={classes.root}>
      <PageHeader title={getTranslate('Price Class Managment')} />
      <AppBar position="static" color="transparent">
        <Tabs
          value={page}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth">
          {visibleTabs.map((tabItem) => (
            <Tab
              key={tabItem.value}
              value={tabItem.value}
              className={classes.tab}
              label={tabItem.label}
              to={tabItem.to}
              component={LocalizedLink}
              disabled={tabItem.value === 'statistic'}
            />
          ))}
        </Tabs>
      </AppBar>
      {visibleTabs.map((tabItem) => (
        <TabPanel
          key={tabItem.value}
          value={page}
          index={tabItem.value}
          dir={theme.direction}
          className={classes.tabPanel}>
          {tabItem.component}
        </TabPanel>
      ))}
      {/* <TabPanel
        value={page}
        index="price-class"
        dir={theme.direction}
        className={classes.tabPanel}>
        <PriceClassList />
      </TabPanel>
      <TabPanel
        value={page}
        index="subscribe"
        dir={theme.direction}
        className={classes.tabPanel}>
        <PriceClassRateConnection />
      </TabPanel>
      <TabPanel
        value={page}
        index="distributions"
        dir={theme.direction}
        className={classes.tabPanel}>
        <PriceClassDistributions />
      </TabPanel>
      <TabPanel
        value={page}
        index="exchange-rates"
        dir={theme.direction}
        className={classes.tabPanel}>
        <PriceClassExchangeRate />
      </TabPanel> */}
    </div>
  )
}
